import { Document } from '@tiptap/extension-document'
import { Text } from '@tiptap/extension-text'
import { Paragraph } from '@tiptap/extension-paragraph'
import { HardBreak } from '@tiptap/extension-hard-break'
import type { Extensions } from '@tiptap/react'
import { Placeholder } from '@tiptap/extension-placeholder'

// for doing transformations/operations
export const commentExtensionsForTransformations = [
  Placeholder.configure({
    placeholder: `Press / to add a block`,
  }),
  Document.configure(),
  Text.configure(),
  Paragraph.configure(),
  HardBreak.configure(),
] satisfies Extensions
